import React from "react";

type Props = {
  label: string;
  onClick: () => void;
  dataTestId: string;
};

export const EditButton = ({ label, onClick, dataTestId }: Props) => {
  return (
    <>
      <button
        onClick={onClick}
        className="btn btn-link btn-sm"
        data-testid={dataTestId}
        type="button"
      >
        {label}
      </button>
    </>
  );
};
